import './index.css';
import '@myosh/odin-components/odin-components.css';
import '@myosh/myosh-login/dist/myosh-login.css';

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider, UserProvider } from '@myosh/myosh-login';

createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Router basename={process.env.PUBLIC_URL}>
      <AuthProvider>
        <UserProvider>
          <App />
        </UserProvider>
      </AuthProvider>
    </Router>
  </React.StrictMode>,
);
